// extracted by mini-css-extract-plugin
module.exports = {"link":"NativeAppsLink_link__0Y_RC"};